import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    AfterViewInit,
    ApplicationRef,
    ChangeDetectorRef,
} from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import {
    PermissionSetPage,
    UserPermissionsService,
    PermissionSetUpdateForm,
    Module,
} from '../../../services/user-permissions.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-permission-set-pages',
    templateUrl: './permission-set-pages.component.html',
    styleUrls: ['./permission-set-pages.component.scss'],
})
export class PermissionSetPagesComponent implements OnInit {
    public gridView: GridDataResult;
    public data: PermissionSetPage[];

    constructor(
        private service: UserPermissionsService,
        private toast: ToastService,
        @Inject(DOCUMENT) document
    ) {}

    @Input() modules: Module[];
    @Output() updatePage = new EventEmitter();
    checkFlag: boolean = false;

    ngOnInit() {
        this.updateGrid(this.modules);
    }

    updateGrid(data) {
        let d = data.pages;
        this.checkFlag = true;
        for (let pg of d) {
            if (pg.page.hasPage == false) {
                this.checkFlag = false;
            }
        }
        this.gridView = {
            data: d,
            total: d.length,
        };
    }

    // Determines which pages need to be updated (IsActive: true/false)
    clickGrantAccess(page: PermissionSetPage, pages: PermissionSetPage[] | Module[]) {
        this.updatePage.emit({ page, pages });
    }

    checkAll() {
        var appName = 'app-permission-set-pages';
        var query = document.querySelector(appName);
        var elements = query.getElementsByTagName('input');
        var mainCheck = elements[0];
        // Skip the first element because it is the header checkbox
        if (mainCheck && mainCheck.checked == false) {
            for (let i = 1; i < elements.length; i++) {
                // If it is a checkbox and not a submodule
                if (
                    elements[i].type == 'checkbox' &&
                    elements[i].checked == true &&
                    !elements[i].className.includes('subModule')
                ) {
                    elements[i].click();
                }
            }
        } else if (mainCheck && mainCheck.checked == true) {
            for (let i = 1; i < elements.length; i++) {
                // If it is a checkbox and not a submodule
                if (
                    elements[i].type == 'checkbox' &&
                    elements[i].checked == false &&
                    !elements[i].className.includes('subModule')
                ) {
                    elements[i].click();
                }
            }
        }
    }

    editPermission() {}
}
